import React from "react";
import { Menu, MenuItem } from "@material-ui/core";
import { MoreVert } from "@material-ui/icons";
import { IconButton } from "@material-ui/core";

const Menus = (props) => {
  const { onMenuClick, options } = props;
  const [anchor, setAnchor] = React.useState(null);
  return (
    <div>
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          setAnchor(e.currentTarget);
        }}
      >
        <MoreVert />
      </IconButton>
      <Menu
        anchorEl={anchor}
        keepMounted
        open={Boolean(anchor)}
        onClose={(e) => {
          setAnchor(null);
          e.stopPropagation();
        }}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        {options.map((option, index) => (
          <MenuItem
            key={option}
            onClick={(e) => {
              setAnchor(null);
              e.stopPropagation();
              onMenuClick(option);
            }}
          >
            {option}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default Menus;
